var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPowerleafAlone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 99,
    viewBox: "0 0 131 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "PowerLeaf-Alone"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2726_45383",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 131,
    height: 99
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.5695 85.8018L67.295 86.1409L67.3026 86.1252L95.464 98.5488L130.948 77.3645L116.562 71.0263L113.326 75.6419L118.909 78.1009L95.0728 92.3334L77.2049 84.4483L103.324 82.4413L127.583 47.7654L89.5831 50.689L86.8491 56.4311L116.305 54.1693L100.23 77.1464L70.5406 79.4261L87.4398 44.4638L65.9548 0L44.5143 44.4507L50.689 44.477L65.9548 12.8298L81.2384 44.4638L65.4445 76.3309L47.749 51.0396L5.15691 47.7654L20.8761 70.2427L25.9618 67.7793L16.4306 54.1693L44.655 56.339L58.4342 76.0294L37.4891 66.7877L0.947266 84.9563L1.63631 85.2631L1.35625 85.2325L31.7589 98.6452L54.6709 84.9695L48.4872 82.208L31.3677 92.4298L21.801 88.2087L19.067 87.0033L13.9725 84.6582L37.6313 72.898L61.8499 83.5836L61.8449 83.5937L65.4195 85.2644L65.4081 85.2895L66.5695 85.8018Z",
    fill: "#EB6E23"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2726_45383)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 121",
    width: 126.672,
    height: 136.994,
    transform: "matrix(-0.71521 -0.69891 0.71521 -0.69891 62.541 157.916)",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerleafAlone);
export default __webpack_public_path__ + "static/media/powerleaf_alone.19497088c046de03b8509f21127fb665.svg";
export { ForwardRef as ReactComponent };